import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  CardHeader,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { connect } from "react-redux";

import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import classnames from "classnames";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const EventDashboard = (props) => {
  document.title = "Dashboard - VUF";
  const [activeTab, setActiveTab] = useState("1");
  const [todayFilter, setTodayFilter] = useState(false);
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Dashboard", link: "#" },
  ];
  // const flatpickrRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  const Values = {
    counts: {
      totalUsers: 0,
      MainAppUsers: 0,
      GBNAppUsers: 0,
      SangathanAppUsers: 0,
      LocationUsers: 0,
      EventUser: 0,
      gbnActiveUsers: 0,
      othersUsers: 0,
    },
    EventList: [],
    LocationList: [],

    selectionRange: {
      startDate: new Date(),
      endDate: new Date(),
    },
    dates: [],
    eventList: [],
    showDatePicker: false,
  };

  const [isLoading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [defaultFilter, setDefaultFilter] = useState(false);
  const [CountValues, setCountValues] = useState(Values);
  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });

  useEffect(() => {
    handleToday();
    setDefaultFilter(!!(startDate && endDate));
  }, [startDate, endDate]);

  // async function fetchData(filter = false) {
  //   let urlPath = "appmanager/dashboard/";

  //   const startDate = Values.selectionRange.startDate;
  //   const endDate = Values.selectionRange.endDate;

  //   fetch(url.VUF_APP_API + urlPath, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       filter: filter,
  //       startDate: startDate,
  //       endDate: endDate,
  //     }),
  //   })
  //     .then((response) => response.json())
  //     .then((responseData) => {
  //       if (responseData.status) {
  //         let formValues = {
  //           counts: {
  //             totalUsers: responseData.data.totalUsers,
  //             mainApp: responseData.data.mainApp,
  //             gbnApp: responseData.data.gbnApp,
  //             sangathanApp: responseData.data.sangathanApp,
  //             eventUsers: responseData.data.eventUsers,
  //             locationUsers: responseData.data.totalLocationsUsers,
  //           },
  //           locations: responseData.data.locations,
  //           eventList: responseData.data.eventList,
  //         };
  //         setValues(formValues);
  //         setLoading(false);
  //       } else {
  //         alert("Something went wrong, Please try again after sometime.");
  //       }
  //     })
  //     .catch((error) => {
  //       alert("Something went wrong, Please try again after sometime.");
  //       // this.setState({ loading: false });
  //     })
  //     .finally((final) => {
  //       setLoading(false);
  //     });
  // }

  // function dateValues(val) {
  //   if (val.length == 2) {
  //     Values.selectionRange.startDate = val[0];
  //     Values.selectionRange.endDate = val[1];
  //     handleToday();
  //     //fetchData(true);
  //   } else {
  //     handleToday();
  //     //fetchData(false);
  //   }
  // }
  // const handleDateChange = (dates) => {
  //   setStartDate(dates[0]); // single date mode returns array
  //   setEndDate(dates[0]); // single date mode returns array
  // };
  const handleReset = () => {
    //handleToday();
    if (startRef.current && startRef.current.flatpickr) {
      startRef.current.flatpickr.clear();
    }
    setStartDate(null);
    if (endRef.current && endRef.current.flatpickr) {
      endRef.current.flatpickr.clear();
    }
    setEndDate(null);
    //setDefaultFilter(false);
  };

  const formatLocalDate = (date) => {
    if (!date) return false;
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${y}-${m.toString().padStart(2, "0")}-${d.toString().padStart(2, "0")}`;
  };

  const handleToday = (type) => {
    let urlPath;
    setLoading(true);
    urlPath = "appmanager/latest-record";

    const body = JSON.stringify({
      dateFilter: !!(startDate && endDate),
      startDate: formatLocalDate(startDate),
      endDate: formatLocalDate(endDate),
    });

    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((responseData) => {
        setLoading(false);
        if (responseData.status) {
          const response = responseData.result;
          let CountsValues = {
            counts: {
              totalUsers: response.TotalUsers,
              MainAppUsers: response.TotalMainAppUsers,
              GBNAppUsers: response.TotalGBNAppUsers,
              gbnActiveUsers: response.gbnActiveUsers,
              othersUsers: response.OtherUsers,
              SangathanAppUsers: response.TotalSangathanBetaAppUsers,
              LocationUsers: response.TotalLocationUsers,
              EventUser: response.TotalEventUser,
            },
            EventList: response.Event,
            LocationList: response.Location,
          };
          setCountValues(CountsValues);

          setLoading(false);
        } else {
          toast.error("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Something went wrong, Please try again after sometime.");
        // this.setState({ loading: false });
      })
      .finally((final) => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">Dashboard</CardTitle>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <Label>Start Date</Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Select start date"
                        value={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          // Optional: if endDate is before new startDate, reset it
                          if (endDate && dates[0] > endDate) {
                            setEndDate(null);
                          }
                        }}
                        options={{
                          mode: "single",
                          dateFormat: "d-m-Y",
                          maxDate: endDate || null, // endDate limits startDate
                        }}
                        ref={startRef}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <Label>End Date</Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Select end date"
                        value={endDate}
                        onChange={(dates) => setEndDate(dates[0])}
                        options={{
                          mode: "single",
                          dateFormat: "d-m-Y",
                          minDate: startDate || null, // startDate limits endDate
                        }}
                        ref={endRef}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 mt-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-lg me-3"
                      onClick={handleToday}
                      style={{
                        outline: "none",
                        boxShadow: "none",
                        transform: "none",
                      }}
                    >
                      <span className="mdi mdi-refresh p-1"></span>
                      Refresh
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-lg"
                      onClick={() => {
                        setDefaultFilter(false);
                        handleReset();
                      }}
                      style={{
                        outline: "none",
                        boxShadow: "none",
                        transform: "none",
                      }}
                    >
                      <span className="mdi mdi-lock-reset p-1"></span>
                      Reset
                    </button>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-account-outline"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            Total Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {/* {form.counts.totalUsers} */}
                            {CountValues.counts.totalUsers || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-calendar-check-outline"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            Event Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {/* {form.counts.eventUsers} */}
                            {CountValues.counts.EventUser || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-map-marker-outline"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            All Locations Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {/* {form.counts.locationUsers} */}
                            {CountValues.counts.LocationUsers || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-castle"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            VUF Main App Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {/* {form.counts.mainApp} */}
                            {CountValues.counts.MainAppUsers || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-hubspot"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            VBN App Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {/* {form.counts.gbnApp} */}
                            {CountValues.counts.GBNAppUsers}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-briefcase-check"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-14 text-white">
                            VBN Active Users
                          </h6>
                          <h2 className="mb-4 text-white">
                            {CountValues.counts.gbnActiveUsers || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <div className="mini-stat-icon">
                          <i className="float-end mdi mdi-briefcase-check"></i>
                        </div>
                        <div className="text-white">
                          <h6 className="text-uppercase mb-3 font-size-16 text-white">
                            VUF Others
                          </h6>
                          <h2 className="mb-4 text-white">
                            {CountValues.counts?.othersUsers || 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-xl-3">
                    <div className="mini-stat bg-primary card">
                      <div className="card-body mini-stat-img card-body">
                        <Link to={"/sangathan-member-list"}>
                          <div className="mini-stat-icon">
                            <i className="float-end mdi mdi-account-group-outline"></i>
                          </div>
                          <div className="text-white">
                            <h6 className="text-uppercase mb-3 font-size-14 text-white">
                              VUF Sangathan Users
                            </h6>
                            <h2 className="mb-4 text-white">
                              {CountValues.counts.SangathanAppUsers || 0}
                            </h2>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <Col xl="12">
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <Col md="6" className="text-end">
                          <Nav>
                            <NavItem>
                              <NavLink
                                className={classnames("text-purple", {
                                  active: activeTab === "1",
                                })}
                                style={{
                                  color:
                                    activeTab === "1" ? "#6f42c1" : "#6f42c1",
                                  borderBottom:
                                    activeTab === "1"
                                      ? "2px solid #6f42c1"
                                      : "none",
                                  paddingBottom: "4px",
                                }}
                                onClick={() => toggle("1")}
                                role="button"
                              >
                                Locations
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames("text-purple", {
                                  active: activeTab === "2",
                                })}
                                style={{
                                  color:
                                    activeTab === "2" ? "#6f42c1" : "#6f42c1",
                                  borderBottom:
                                    activeTab === "2"
                                      ? "2px solid #6f42c1"
                                      : "none",
                                  paddingBottom: "4px",
                                }}
                                onClick={() => toggle("2")}
                                role="button"
                              >
                                Event
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      {activeTab === "1" && (
                        <div className="row">
                          {CountValues.LocationList?.length > 0 ? (
                            CountValues.LocationList?.map((loc, i) => {
                              return (
                                <div className="col-md-6 mb-4" key={i}>
                                  <div className="card shadow-sm p-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <div className="small">
                                          Location Name
                                        </div>
                                        <div className="fs-4">{loc.name}</div>
                                      </div>
                                      <div className="d-flex gap-4 text-end">
                                        <div>
                                          <div className="text-muted small">
                                            Users
                                          </div>
                                          <div className="fs-5">
                                            {loc.totalUsers || 0}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-muted small">
                                            QR Scan Count
                                          </div>
                                          <div className="fs-5">
                                            {loc.totalQrScan || 0}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="col-md-12">
                              <div className="card card-body">
                                <div className="h4 ">No Locations</div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {activeTab === "2" && (
                        <div className="row">
                          {CountValues.EventList.length > 0 ? (
                            CountValues.EventList.map((event, i) => {
                              return (
                                <div className="col-md-6">
                                  <div className="card card-body">
                                    <div className="hstack gap-3">
                                      <div>
                                        <div className="text-muted">
                                          Event Name
                                        </div>
                                        <div className="h4 ">
                                          {event.eventName}
                                        </div>
                                      </div>
                                      <div className="ms-auto">
                                        <div className="text-muted">Users</div>
                                        <div className="h4 ">
                                          {event.totalUsers}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="col-md-12">
                              <div className="card card-body">
                                <div className="h4 ">No Events</div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      <div className="row"></div>
                    </CardBody>
                  </Card>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(EventDashboard);
